export default {
    count_active: 'Activar a sua conta!',
    days: 'dias.',
    expired: 'O seu período experimental expirou, active a sua conta!',
    you_have: 'Tem ',
    take_session: ' Para marcar a sua sessão de formação gratuita.',
    take_now: ' Reserve agora.',
}

